import Header from "./Header";
import Main from "./Main";
import SideLeft from "./SideLeft";
import SideRight from "./SideRight";
import TransactionsNavigation from "./TransactionsNavigation";
import ThumbnailSelectorModal from "./UI/Modals/ThumbnailSelector";
import DocModalUpload from "./shared/DocModalUpload";
import CDAUploadModal from "./shared/CDAUploadModal";
import Preview from "./Main/Docs/Preview";
import { TDPImportListingDetailsModal } from "./Main/Details/ImportListingDetailsModal";
import { TDPUpdateTransactionModal } from "./Main/Details/UpdateTransactionModal";

const App = () => (
  <>
    <Preview />
    <DocModalUpload />
    <CDAUploadModal />
    <div className="tw-h-full tw-overflow-auto" id="tdp-app">
      <div className="tw-min-w-[1336px] tw-p-24px">
        <TransactionsNavigation />
        <Header />
        <div className="tw-flex tw-flex-nowrap tw-gap-x-16px">
          <SideLeft />
          <Main />
          <SideRight />
        </div>
        <ThumbnailSelectorModal />
        <TDPImportListingDetailsModal />
        <TDPUpdateTransactionModal />
      </div>
    </div>
  </>
);

export default App;
